import {FetchApi} from '../lib/anuket-http';
import {getToken} from '../utils/isLoggedIn';

/**
 * Error logging through anubis
 * @param user
 * @param url
 * @param msg
 * @param browserInfo
 */
export async function logError(user, url, msg, browserInfo) {
  const token = await getToken();
  FetchApi.doFetch(
    '/logError',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        user,
        url,
        logMessage: msg,
        browserInfo
      })
    }
  ).subscribe(() => {});
}



/** WEBPACK FOOTER **
 ** ./data/Logging.js
 **/